import React from 'react';
import * as Styled from './styles';
import Image from 'next/image';
import {
  ZONE_TERMS_CONDITIONS_URL,
  ZONE_PRIVACY_POLICY_URL,
  imageUrls,
} from '../../../utils/constants';

function Footer() {
  return (
    <Styled.FooterContainer>
      <Styled.FooterSubBlock>
        <div>
          <Image
            src={imageUrls.footerLogo}
            alt="Footer Logo"
            placeholder="blur"
            quality={100}
          />
        </div>
        <Styled.FooterTextBlock>
          <Styled.FooterItem href={ZONE_TERMS_CONDITIONS_URL} target="_blank">
            Terms and Conditions
          </Styled.FooterItem>
          <Styled.FooterItem href={ZONE_PRIVACY_POLICY_URL} target="_blank">
            Privacy Policy
          </Styled.FooterItem>
        </Styled.FooterTextBlock>
      </Styled.FooterSubBlock>
    </Styled.FooterContainer>
  );
}

export default Footer;
